require('../../../libs/backbone/backbone.ajaxq.adapter.ts');
var Handlebars = require('handlebars');

var Template = require('text-loader!../../templates/queue_monitor_templates/empty_monitor.template.htm');
var i18n = require('l10n');

require('../../../libs/jquery-dynamicFontSize/jquery-dynamicFontSize.js');

var TheView = Backbone.View.extend({
    el: $("#container"),
    tagName: 'div',
	template: Handlebars.compile(Template),
	initialize: function (options) {
        this.render();
	},
	superRender: Backbone.View.prototype.render,
    render: function() {
        this.$el.html(this.template(  ));
    },
	events:{

	},
	data: function(collection) {
        this.render();
    },
    destroy: function() {

    }
});

module.exports = TheView;